import {Scene} from 'scene';

import {Animation} from 'animation';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

const GAME_OFFSET = {
    x: 587,
    y: 436
};

const GAME_START_POS = {
    x: 90,
    y:103
};

const FRAME_START_POS = {
    x: 83,
    y: 96
};

export const PRELOADER = 'load_wheel_%03d.png'
export const PRELOADER_FRAMES = 12

export default class SceneLobby extends Scene {
    constructor(space, games) {
        super();

        this.space = space;

        const lobbyBackground = new Sprite(TextureCache['res/main_screen.png']);
        this.addChild(lobbyBackground);

        const lobbyUpUIPanel = new Sprite(TextureCache['res/lobby_up_panel_ui.png']);
        this.addChild(lobbyUpUIPanel);

        const lobbyDownUIPanel = new Sprite(TextureCache['res/lobby_down_panel_ui.png']);
        lobbyDownUIPanel.position.set(0, 983);
        this.addChild(lobbyDownUIPanel);

        this.resultLabel = new BitmapText("", {font: "result_font", align: "center"});
        this.resultLabel.anchor.set(0.5, 0);
        this.resultLabel.position.set(200, 36);
        lobbyDownUIPanel.addChild(this.resultLabel);

        // добавим остальные иконки, пока нет игр, что бы в лобби не было пусто
        const gameList = [41, 45, 40, 42, 55, 56];
        let allGames = games.slice();
        if (allGames.length < gameList.length) {
            for (let i = allGames.length; i < gameList.length; ++i) {
                allGames.push('game_' + gameList[i]);
            }
        }
        this.gamesIcon = [];
        for (let i = 0; i < allGames.length; ++i) {
            let icon = new Sprite(TextureCache['res/game_icons/icon_' + allGames[i] + '.png']);
            icon.x = GAME_START_POS.x + Math.floor(i%3) * GAME_OFFSET.x;
            icon.y = GAME_START_POS.y + Math.floor(i/3) * GAME_OFFSET.y;

            this.addChild(icon);
            this.gamesIcon.push(icon);
        }

        this.gameFocusFrame = new Sprite(TextureCache['res/game_icons/games_choice_frame.png']);
        this.gameFocusFrame.position.set(FRAME_START_POS.x, FRAME_START_POS.y);
        this.addChild(this.gameFocusFrame);

        this.preloaders = [];
        for (let i = 0; i < 6; ++i) {
            let preloader = Animation.byFrameName( PRELOADER, PRELOADER_FRAMES );
            preloader.animationSpeed = 0.2;
            preloader.loop = true;
            preloader.anchor.set(0.5, 0.5);
            preloader.x = GAME_START_POS.x + Math.floor(i%3) * GAME_OFFSET.x + 562/2;
            preloader.y = GAME_START_POS.y + Math.floor(i/3) * GAME_OFFSET.y + 421/2;
            preloader.visible = false;
            this.addChild(preloader);
            this.preloaders.push(preloader);
        }

        this.currentGameFocusId = 0;

        this.gameOpenCallback = null;

        this.gameLoading = false;
    }

    //fake preloader games
    showLoaders() {
        this.gameLoading = true;
        this.hideGameMenu();

        this.preloaders.forEach(p => {
            p.visible = true;
            p.gotoAndPlay(0);
        });
    }

    loadComplete() {
        this.preloaders.forEach(p => {
            p.visible = false;
            p.gotoAndStop(0);
        });

        this.closeGame();
        this.gameLoading = false;
    }

    setNextGameFocus() {
        if (!this.gameLoading) {
            this.currentGameFocusId = Math.floor((this.currentGameFocusId + 1) % 6);
            this.gameFocusFrame.x = FRAME_START_POS.x + Math.floor(this.currentGameFocusId % 3) * GAME_OFFSET.x;
            this.gameFocusFrame.y = FRAME_START_POS.y + Math.floor(this.currentGameFocusId / 3) * GAME_OFFSET.y;
        }
    };

    setPrevGameFocus() {
        if (!this.gameLoading) {
            this.currentGameFocusId = (this.currentGameFocusId === 0) ? 5 : this.currentGameFocusId - 1;
            this.gameFocusFrame.x = FRAME_START_POS.x + Math.floor(this.currentGameFocusId % 3) * GAME_OFFSET.x;
            this.gameFocusFrame.y = FRAME_START_POS.y + Math.floor(this.currentGameFocusId / 3) * GAME_OFFSET.y;
        }
    };

    setBalance(balance) {
        this.resultLabel.text = balance;
    }

    setGameOpenCallback(cb) {
        this.gameOpenCallback = cb;
    }

    openGame() {
        if ( !this.gameLoading) {
            // this.gamesIcon[this.currentGameFocusId].visible = false;
            // this.gameFocusFrame.visible = false;
            this.space.s( 'run_game' ).next(this.currentGameFocusId);
        }
    }

    onGameOpen() {
        this.gamesIcon[this.currentGameFocusId].visible = false;
        this.gameFocusFrame.visible = false;
    }

    hideGameMenu() {
        this.gamesIcon.forEach(icon => icon.visible = false);
        this.gameFocusFrame.visible = false;
    }

    closeGame() {
        this.gamesIcon.forEach(icon => icon.visible = true);
        this.gameFocusFrame.visible = true;
    }

}



// WEBPACK FOOTER //
// ./src/lobby_scene.es6